module.exports = __webpack_public_path__ + "img/zu_logistica.jpg";